export enum StatoCorrispondenzaEnum {
  FASCICOLATA = <any>"FASCICOLATA",
  ACCETTATA = <any>"ACCETTATA",
  PROTOCOLLATA = <any>"PROTOCOLLATA",

}
